import { render, staticRenderFns } from "./repairForm.vue?vue&type=template&id=0281bf85&scoped=true&"
import script from "./repairForm.vue?vue&type=script&lang=js&"
export * from "./repairForm.vue?vue&type=script&lang=js&"
import style0 from "./repairForm.vue?vue&type=style&index=0&id=0281bf85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0281bf85",
  null
  
)

export default component.exports